import React from "react";

import { SentinelInfoSection } from "./sentinel-info-section";
import { AFT_ONLY_SUFFIX, LEADERSHIP_OTHER_ORGS_MESSAGE } from "src/web/constants";
import { DependencyCoverageSection } from "src/web/components/DependencyCoverage";
import { LeadershipMonitorSchedule } from "src/web/components/MonitorSchedules";

export const SentinelLeadershipDashboardInfoSection = () => (
    <SentinelInfoSection header={`Leadership Dashboard ${AFT_ONLY_SUFFIX}`}>
        <div>
            <p>
                <strong>{LEADERSHIP_OTHER_ORGS_MESSAGE}</strong> Aliases outside the AFT org
        have no data on this page, even when their packages are onboarded to Dependency
        Sentinel and visible elsewhere on this site.
            </p>
            <p>
        The Leadership Dashboard rolls up dependency risk across a manager&apos;s org. It shows
        the packages owned by everyone under the selected manager and how many of their
        dependencies need attention. The page opens on the top-level manager we support
        today (AFT).
            </p>
            <DependencyCoverageSection />
            <h4>How it works</h4>
            <ol>
                <li>Use the Organization panel to pick a manager: click a name to view their org, or expand the caret to browse their reports without leaving the current view.</li>
                <li>Click a name in the management chain above the selected manager to move back up, or enter an alias and press Enter or Load.</li>
                <li>Expand a package in the Packages table to see each of its dependencies.</li>
                <li>Click Download details (CSV) to export every package and dependency for the org.</li>
            </ol>
            <h4>Summary totals</h4>
            <p>
        The totals at the top cover the manager&apos;s whole org. A package or dependency shared by
        several teams is counted once. The date shown is when the data was last refreshed.
            </p>
            <h4>When data refreshes</h4>
            <LeadershipMonitorSchedule />
            <h4>Risk Levels</h4>
            <ul>
                <li><strong>HIGH_RISK</strong> — Negative guidance exists and no recommended upgrade is available.</li>
                <li><strong>AT_RISK</strong> — Negative guidance exists but a recommended upgrade is available.</li>
                <li><strong>UPGRADE_AVAILABLE</strong> — Current version is acceptable but a newer version exists.</li>
                <li><strong>NO_ACTION_REQUIRED</strong> — Current version is acceptable and up to date.</li>
            </ul>
        </div>
    </SentinelInfoSection>
);
